import { render } from "./QueueView.vue?vue&type=template&id=51888b04&scoped=true&ts=true"
import script from "./QueueView.vue?vue&type=script&lang=ts"
export * from "./QueueView.vue?vue&type=script&lang=ts"

import "./QueueView.vue?vue&type=style&index=0&id=51888b04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51888b04"]])

export default __exports__